const LAST_OPEN_KEY = 'last_open';
const POPUP_MESSAGE_DISMISSED_KEY = 'popup_message_dismissed';
const MS_IN_DAY = 24 * 60 * 60 * 1000;

const readTimestamp = (key) => {
    try {
        const timestamp = parseInt(localStorage.getItem(key), 10);
        return Number.isNaN(timestamp) ? 0 : timestamp;
    } catch (e) {
        console.error(e);
        return 0;
    }
};

const writeTimestamp = (key) => {
    try {
        localStorage.setItem(key, new Date().getTime().toString());
    } catch (e) {
        console.error(e);
    }
};

const dayHasPassedSince = (timestamp) => {
    return (new Date().getTime() - timestamp) / MS_IN_DAY >= 1;
};

// AutoPopup Settings: the chatbot auto-opens at most once a day
export const canAutoOpenChatbot = () => dayHasPassedSince(readTimestamp(LAST_OPEN_KEY));

export const saveChatbotLastOpen = () => writeTimestamp(LAST_OPEN_KEY);

// Popup Message Settings: a dismissed teaser stays hidden for the rest of the
// visit. sessionStorage keeps the flag through page loads in the same tab and
// drops it once the visitor closes the tab.
export const canShowPopupMessage = () => {
    try {
        return sessionStorage.getItem(POPUP_MESSAGE_DISMISSED_KEY) === null;
    } catch (e) {
        console.error(e);
        return true;
    }
};

export const savePopupMessageDismissal = () => {
    try {
        sessionStorage.setItem(POPUP_MESSAGE_DISMISSED_KEY, 'true');
    } catch (e) {
        console.error(e);
    }
};
